import { useEffect, useRef } from 'react';

interface Props {
  onClose: () => void;
}

const SHORTCUTS = [
  { key: 'Cmd/Ctrl+K', action: 'Open command palette (navigate, change theme, sign out, search projects)' },
  { key: '?', action: 'Toggle this help' },
  { key: 'Space', action: 'Play / Pause (plays selection if active)' },
  { key: 'Enter', action: 'Stop (reset cursor to start)' },
  { key: '\u2190 / \u2192', action: 'Select previous / next region' },
  { key: 'Delete / Backspace', action: 'Delete selected region' },
  { key: 'Escape', action: 'Clear selection / Close modal' },
  { key: 'L', action: 'Toggle loop on selection' },
  { key: '+ / -', action: 'Zoom in / out' },
  { key: 'Ctrl+Z', action: 'Undo' },
  { key: 'Ctrl+Shift+Z', action: 'Redo' },
];

export function ShortcutsModal({ onClose }: Props) {
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeRef.current?.focus();
  }, []);

  return (
    <div className="modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Keyboard Shortcuts</h3>
          <button ref={closeRef} onClick={onClose} className="btn btn-sm" aria-label="Close shortcuts dialog">Close</button>
        </div>
        <table className="shortcuts-table">
          <tbody>
            {SHORTCUTS.map((s) => (
              <tr key={s.key}>
                <td><kbd>{s.key}</kbd></td>
                <td>{s.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
